import RootRouter from "./router/RootRouter";
import './App.css';
import {ThemeContextProvider} from "./theme/ThemeContext";
import {Toaster} from "react-hot-toast";
import ErrorBoundary from "./components/ErrorBoundary";
import './global.css';


function App() {
    return (
        <ThemeContextProvider>
            <ErrorBoundary>
                <RootRouter/>
                <Toaster
                    position="top-center"
                    reverseOrder={false}
                    toastOptions={{
                        duration: 4000,
                        style: {
                            borderRadius: '8px',
                            padding: '12px 16px',
                            fontSize: '14px',
                            fontWeight: 500,
                        },
                    }}
                />
            </ErrorBoundary>
        </ThemeContextProvider>
    );
}

export default App;
